import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewVolopPageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewVolopPage" */
      './ViewVolopPage.dynamic'
    ),
  loading: LoadingPageLoadable,
});
